module.exports = __webpack_public_path__ + "static/media/clinica_vespucio.95a069bc.png";